import { jsxs as _jsxs, jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { renderArrows } from '../../ui-kit/LinkButton/renderArrows.js';
export const TariffsTableWrapper = JSX(({ children, controls }) => {
    const { isScrollAvailable } = controls;
    return (_jsxs("div", { role: "table", className: "overflow-x-auto w-auto grid md:block", children: [_jsxs("div", { className: "relative space-y-xs", children: [children, renderArrows({
                        ...controls,
                        btnClass: ['top-28', 'top-11'],
                        className: 'right-7',
                    })] }), isScrollAvailable ? (_jsx("div", { className: "absolute top-0 right-0 bottom-0 w-20 bg-opacity-to-white" })) : null] }));
});
//# sourceMappingURL=TariffsTableWrapper.js.map